import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../css/style.css'; // Previously: './Contact.css';
import Logo from '../assets/logo.svg'; // Import SVG logo
import ImageSlider from '../components/ImageSlider'; // Import komponente za slajder

const ContactLive = () => {
    const { slug } = useParams(); // Dohvati slug iz URL-a
    const [contacts, setContacts] = useState(null); // Postavi početnu vrednost na `null`
    const [sliderImages, setSliderImages] = useState([]); // Slike za slajder
    const [coverImage, setCoverImage] = useState('/images/noimage.jpg'); // Default slika
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Dohvati kontakte vezane za ovaj smeštaj
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/contacts`);
                setContacts(response.data.contacts || []); // Ako nema kontakata, postavi na prazan niz

                // Dohvati slike za slajder i cover image
                const accommodationResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}`
                );

                const images = accommodationResponse.data.slider_images
                    ? accommodationResponse.data.slider_images
                        .split(';')
                        .map((img) => `${process.env.REACT_APP_BACKEND_URL}/${img}`)
                    : [];

                if (images.length > 0) {
                    setSliderImages(images); // Ako postoje slike, koristi ih za slajder
                } else if (accommodationResponse.data.cover_image) {
                    // Ako nema slika za slajder, koristi cover_image
                    setCoverImage(`${process.env.REACT_APP_BACKEND_URL}/${accommodationResponse.data.cover_image}`);
                }

                setLoading(false);
            } catch (err) {
                console.error('Error fetching contacts:', err);
                setError('Failed to load contacts.');
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]);

    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    fontFamily: 'Montserrat, sans-serif',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                }}
            >
                <img
                    src={Logo} // Učitavanje SVG logoa
                    alt="Loading logo"
                    style={{ width: '150px', marginBottom: '20px' }}
                />
                <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>Loading...</p>
            </div>
        );
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!contacts || contacts.length === 0) {
        return (
            <div>
                <div className="header-slider">
                    {sliderImages.length > 0 ? (
                        <ImageSlider images={sliderImages} />
                    ) : (
                        <div
                            className="header-image"
                            style={{
                                backgroundImage: `url(${coverImage})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                height: '300px',
                                width: '100vw',
                            }}
                        />
                    )}
                </div>
                <div className="content-boxed">
                    <div className="breadcrumb-container">
                        <p className="breadcrumb">
                            <Link to={`/accommodations/${slug}`} className="breadcrumb-link">Home</Link>
                            <span className="breadcrumb-divider"> &gt; </span>
                            <span className="current-page">Contact</span>
                        </p>
                    </div>
                    <p>No contacts are available for this accommodation at the moment.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="contact-page">
            <div className="header-slider">
                {sliderImages.length > 0 ? (
                    <ImageSlider images={sliderImages} />
                ) : (
                    <div
                        className="header-image"
                        style={{
                            backgroundImage: `url(${coverImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '300px',
                            width: '100vw',
                        }}
                    />
                )}
            </div>
            <div className="content-boxed">
                <div className="breadcrumb-container">
                    <p className="breadcrumb">
                        <Link to={`/accommodations/${slug}`} className="breadcrumb-link">Home</Link>
                        <span className="breadcrumb-divider"> &gt; </span>
                        <span className="current-page">Contact</span>
                    </p>
                </div>

                <div className="contact-list">
                    {contacts.map((contact) => (
                        <div className="contact-item" key={contact.id}>
                            <h2>{contact.name}</h2>
                            {contact.phone && (
                                <p>
                                    <strong>Phone: </strong>
                                    <a href={`tel:${contact.phone}`}>{contact.phone}</a>
                                </p>
                            )}
                            {contact.email && (
                                <p>
                                    <strong>Email: </strong>
                                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                </p>
                            )}
                            {contact.address && (
                                <p>
                                    <strong>Address: </strong>
                                    {contact.address}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ContactLive;